import { Injectable } from '@angular/core';
import { topbar } from '../modal/topbar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopbarService {

  constructor() { }

  private topbarValue = new BehaviorSubject<topbar>({ title: '', buttonName: '', isActiveButton: false, isSearchbox: false, searchPlaceHolder: '', searchValue: '',buttonUrlLink: '' })
  topbarDetailsValue$ = this.topbarValue.asObservable();

  setTopbar(payload: topbar) {
    this.topbarValue.next(payload)
  }
}
